
import React from 'react';
import { Users, Wallet, TrendingUp } from 'lucide-react';
import { CardContent } from '@/components/ui/card';
import { formatNumber } from './utils/formatting';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '@/hooks/use-mobile';

interface BotDetailsSectionProps {
  profitShare: number;
  subscribersTotal: number;
  connectedAccountsTotal: number;
  minCapital: number;
}

export const BotDetailsSection = ({
  profitShare,
  subscribersTotal,
  connectedAccountsTotal,
  minCapital
}: BotDetailsSectionProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  
  return (
    <CardContent className={`py-2 px-4 md:px-6 flex-grow`}>
      <div className="flex items-center justify-between mb-2 md:mb-3">
        <div className={`${isMobile ? "text-xs" : "text-sm"} text-muted-foreground`}>{t('profit_share')}</div>
        <div className={`font-medium ${isMobile ? "text-base" : "text-lg"}`}>{profitShare}%</div>
      </div>
      
      <div className="grid grid-cols-2 gap-y-1.5 md:gap-y-2 gap-x-2 md:gap-x-4 text-xs md:text-sm">
        <div className="flex items-center gap-1">
          <Users className={`${isMobile ? "h-3.5 w-3.5" : "h-4 w-4"} text-muted-foreground`} />
          <span>{formatNumber(subscribersTotal)}</span>
        </div>
        
        <div className="flex items-center gap-1">
          <Wallet className={`${isMobile ? "h-3.5 w-3.5" : "h-4 w-4"} text-muted-foreground`} />
          <span>${formatNumber(minCapital)}</span>
        </div>
        
        <div className="flex items-center gap-1 col-span-2">
          <TrendingUp className={`${isMobile ? "h-3.5 w-3.5" : "h-4 w-4"} text-muted-foreground`} />
          <span>{formatNumber(connectedAccountsTotal)} {t('connected_accounts')}</span>
        </div>
      </div>
    </CardContent>
  );
};
